/**
 *
 */
interface ICompanyInfo {
  companyName: OrderExcelData;
  postCode: OrderExcelData;
  address: OrderExcelData;
  staffName: OrderExcelData;
  tel: OrderExcelData;
  fax: OrderExcelData;
  createAt?: number;
  updatedAt?: number;
}

/**
 *
 */
interface ICompanyInfoGroup {
  [key: string]: ICompanyInfo;
}

/**
 *
 */
interface IOutputExcelProperty {
  displayCell: string;
  isDisplay: boolean;
}

/**
 *
 */
interface IUserCustomExcelInfo {
  colName: string;
  displayCell: string;
  isDisplay: boolean;
}

/**
 *
 */
interface IUserCustomExcelInfoGroup {
  [key: string]: IUserCustomExcelInfo;
}

/**
 *
 */
type IOutputExcelFileInfoUnion =
  | 'businessId'
  | 'endUser'
  | 'salesDestinationName'
  | 'supplierName'
  | 'deliveryDestinationName'
  | 'businessName'
  | 'note'
  | 'unit'
  | 'form'
  | 'leadTime'
  | 'MOQ'
  | 'stdInventoryIndex'
  | 'fixOrderDate'
  | 'orderAmount'
  | 'deliveryDate';

/**
 *
 */
type IOutputExcelFileInfo = Record<IOutputExcelFileInfoUnion, IOutputExcelProperty>;

/**
 *
 */
interface OrderExcelData {
  column: string;
  displayCell: string;
  isDeletable: boolean;
}

// TODO: このユニオンを可変で作成するようにする
/**
 *
 */
type IOutputFirmOrderExcelInfoUnion =
  | 'receiveOrderDate' // 受注日
  | 'quantity' // 個数 = 発注数量÷容量
  | 'amount' // 推奨発注数量 or 確定発注数量
  | 'fixOrderDate' // 発注日
  | 'crossDate' // 推奨納入日 or 納入日
  | 'createDate' // 作成日 (エクセル出力日)
  // 取引情報のベース部分
  | 'businessId'
  | 'businessName'
  | 'businessNumber'
  | 'package' // 容量
  | 'endUser'
  | 'salesDestinationName'
  | 'leadTime' // リードタイム
  | 'supplierName'
  | 'deliveryDestinationName'
  | 'stdInventoryIndex'
  | 'warehouse'
  | 'inventory'
  | 'note'
  | 'unit'
  | 'form';

/**
 *
 */
type IOutputFirmOrderExcelInfo = IOutputExcelProperty & { rowName: string };

/**
 *
 */
type IOutputFirmOrderExcelFileInfo = Record<IOutputFirmOrderExcelInfoUnion, IOutputFirmOrderExcelInfo>;
// 長瀬書式の確定発注エクセルの情報出力場所の固定値 (サンプルのようなもの)
// TODO: この内容を設定ページで作成できるようにする
export const sampleOutputFirmOrderExcelInfo: IUserCustomExcelInfoGroup = {
  receiveOrderDate: {
    colName: '受注日',
    displayCell: '',
    isDisplay: false,
  },
  package: {
    colName: '容量',
    displayCell: 'H3',
    isDisplay: true,
  },
  quantity: {
    colName: '個数',
    displayCell: '',
    isDisplay: false,
  },
  amount: {
    colName: '発注数量',
    displayCell: 'B3',
    isDisplay: true,
  },
  leadTime: {
    colName: 'リードタイム',
    displayCell: 'K3',
    isDisplay: true,
  },
  fixOrderDate: {
    colName: '発注日',
    displayCell: 'A3',
    isDisplay: true,
  },
  crossDate: {
    colName: '希望納期',
    displayCell: 'C3',
    isDisplay: true,
  },
  createDate: {
    colName: '',
    displayCell: '',
    isDisplay: false,
  },
  businessId: {
    colName: '',
    displayCell: '',
    isDisplay: false,
  },
  endUser: {
    colName: '',
    displayCell: '',
    isDisplay: false,
  },
  salesDestinationName: {
    colName: '売上先',
    displayCell: 'I3',
    isDisplay: true,
  },
  supplierName: {
    colName: '仕入先',
    displayCell: 'E3',
    isDisplay: true,
  },
  deliveryDestinationName: {
    colName: '送り先',
    displayCell: 'J3',
    isDisplay: true,
  },
  businessName: {
    colName: '商品名',
    displayCell: 'G3',
    isDisplay: true,
  },
  stdInventoryIndex: {
    colName: '標準在庫指数',
    displayCell: 'L3',
    isDisplay: true,
  },
  warehouse: {
    colName: '置場名',
    displayCell: 'D3',
    isDisplay: true,
  },
  inventory: {
    colName: '在個数',
    displayCell: 'M3',
    isDisplay: true,
  },
  businessNumber: {
    colName: '商品CD',
    displayCell: 'F3',
    isDisplay: true,
  },
  note: {
    colName: '',
    displayCell: '',
    isDisplay: false,
  },
  unit: {
    colName: '単位',
    displayCell: '',
    isDisplay: false,
  },
  form: {
    colName: '荷姿',
    displayCell: '',
    isDisplay: false,
  },
};

export const sampleCustomFirmOrderExcelInfo: IUserCustomExcelInfoGroup = {
  receiveOrderDate: {
    colName: '受注日',
    displayCell: 'K5',
    isDisplay: true,
  },
  package: {
    colName: '容量',
    displayCell: 'U5',
    isDisplay: true,
  },
  quantity: {
    colName: '個数',
    displayCell: 'W5',
    isDisplay: true,
  },
  orderAmount: {
    colName: '数量',
    displayCell: 'X5',
    isDisplay: true,
  },
  desiredDeliveryDate: {
    colName: '希望納期',
    displayCell: 'AC5',
    isDisplay: true,
  },
  createDate: {
    colName: '作成日',
    displayCell: 'AR5',
    isDisplay: true,
  },
  expectedShippingDate: {
    colName: '出荷予定日',
    displayCell: 'AA5',
    isDisplay: true,
  },
  businessMemo: {
    colName: '顧客台帳ID',
    displayCell: 'I5',
    isDisplay: true,
  },
  buyOrderNumber: {
    colName: '買注文NO',
    displayCell: 'AI5',
    isDisplay: true,
  },
};

export const defaultFormatFirmOrderExcelInfo: IUserCustomExcelInfoGroup = {
  orderId: {
    colName: 'LP発注番号',
    displayCell: 'A3',
    isDisplay: true,
  },
  createdOrderDate: {
    colName: '発注日',
    displayCell: 'B3',
    isDisplay: true,
  },
  orderAmount: {
    colName: '発注数量',
    displayCell: 'C3',
    isDisplay: true,
  },
  desiredDeliveryDate: {
    colName: '希望納期',
    displayCell: 'D3',
    isDisplay: true,
  },
  estimatedTimeOfArrival: {
    colName: '納期',
    displayCell: 'E3',
    isDisplay: true,
  },
  warehouseNumber: {
    colName: '置場CD',
    displayCell: 'F3',
    isDisplay: true,
  },
  warehouse: {
    colName: '置場名',
    displayCell: 'G3',
    isDisplay: true,
  },
  supplierNumber: {
    colName: '仕入先CD',
    displayCell: 'H3',
    isDisplay: true,
  },
  supplierName: {
    colName: '仕入先名',
    displayCell: 'I3',
    isDisplay: true,
  },
  manufacturer: {
    colName: '製造者',
    displayCell: 'J3',
    isDisplay: true,
  },
  businessNumber: {
    colName: '商品CD',
    displayCell: 'K3',
    isDisplay: true,
  },
  businessName: {
    colName: '商品名',
    displayCell: 'L3',
    isDisplay: true,
  },
  package: {
    colName: '容量',
    displayCell: 'M3',
    isDisplay: true,
  },
  unit: {
    colName: '単位',
    displayCell: 'N3',
    isDisplay: true,
  },
  orderNumber: {
    colName: 'ユーザー発注番号',
    displayCell: 'O3',
    isDisplay: true,
  },
  aggregateBusinessResponsibleUsers: {
    colName: '仕入担当者',
    displayCell: 'P3',
    isDisplay: true,
  },
  orderNote: {
    colName: 'メモ',
    displayCell: 'Q3',
    isDisplay: true,
  },
  businessMemo: {
    colName: 'ユーザー固有番号',
    displayCell: 'R3',
    isDisplay: true,
  },
  // 売上先
  // 送り先名
  // リードタイム
  // 標準在庫指数
  // 現在個数
};

export { IOutputExcelFileInfo, ICompanyInfo, ICompanyInfoGroup, IUserCustomExcelInfoGroup, OrderExcelData, IOutputFirmOrderExcelFileInfo };
